import {
  UserPermissionToVideoRecordRole,
  VideoRecordStatusConvert,
  VideoRecordTeamMembersPermission,
} from '@distribute/shared/types';

import { VideoRecordType } from '@distribute/shared/api-types/video-record';

export const filterByRecordsMy = (records: VideoRecordType[], userId: string) =>
  records.filter((v) =>
    v.userPermissionToVideoRecords.some(
      (uV) =>
        uV.user.id === userId &&
        uV.role === UserPermissionToVideoRecordRole.OWNER
    )
  );

export const filterByRecordsConverted = (records: VideoRecordType[]) =>
  records.filter((r) => r.statusConvert === VideoRecordStatusConvert.COMPLETED);

export const filterByRecordsShared = (
  records: VideoRecordType[],
  userId: string
) =>
  records.filter((v) => {
    if (
      v.userPermissionToVideoRecords.some(
        (uV) =>
          uV.user.id === userId &&
          uV.role === UserPermissionToVideoRecordRole.OWNER
      )
    ) {
      return false;
    }

    if (
      v.userPermissionToVideoRecords.some(
        (uV) =>
          uV.user.id === userId &&
          [
            UserPermissionToVideoRecordRole.VIEWER,
            UserPermissionToVideoRecordRole.EDITOR,
          ].includes(uV.role)
      )
    ) {
      return true;
    }

    return (
      v.teamMembersPermission !== VideoRecordTeamMembersPermission.INVITE_ONLY
    );
  });
